import { useEffect, useState } from 'react';
import { usePrevious } from '@core/hooks/usePrevious';
/**
 * Hook to subscribe and return loading/playing status of a video
 */
export const useVideoPlayStatus = (videoWrapper) => {
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const wasVideoPlaying = usePrevious(isVideoPlaying);
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    useEffect(() => {
        if (!videoWrapper) {
            return;
        }
        const onLoadedData = () => {
            setIsVideoLoaded(true);
        };
        videoWrapper.addEventListener('loadeddata', onLoadedData);
        const onPlay = () => {
            setIsVideoPlaying(true);
        };
        videoWrapper.addEventListener('play', onPlay);
        const onPause = () => {
            setIsVideoPlaying(false);
        };
        videoWrapper.addEventListener('pause', onPause);
        return () => {
            videoWrapper.removeEventListener('play', onPlay);
            videoWrapper.removeEventListener('loadeddata', onLoadedData);
            videoWrapper.removeEventListener('pause', onPause);
        };
    }, [videoWrapper]);
    return { isVideoPlaying, wasVideoPlaying, isVideoLoaded };
};
